import RegistrationHandler from '@components/Registration/RegistrationHandler';
import { useStore } from '@store/appStore';
import { memo } from 'react';
import { useAuthentication } from '@providers/AuthProvider';
import { shallow } from 'zustand/shallow';
import ProfilePage from '@components/Pages/ProfilePage';
import DefaultLoader from '@components/Loaders/DefaultLoader';

import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import GuardianPage from '@components/Pages/GuardianPage';
import CounselorPage from '@components/Pages/CounselorPage';
import StudentAdminPage from '@components/Pages/StudentAdminPage';
import RedeemQRPage from '@components/Pages/RedeemQRPage';
import RewardPage from '@components/Pages/RewardPage';
import RedeemPage from '@components/Pages/RedeemPage';
import DefaultTemplate from '@templates/DefaultTemplate';
import LeaderPage from '@components/Pages/LeaderPage';
import SchoolSecretaryPage from '@components/Pages/SchoolSecretaryPage';
import { useWindowSize } from 'react-use';
import { breakpoints } from '@styles/tokens';
import QROnlyPage from '@components/Pages/QROnlyPage';

const { code, errorText } = { code: 401, errorText: 'You are not authorized to access this page' };

export const LoaderWrapper = styled.div`
  position: relative;
  height: var(--site-height);
  width: 100%;
`;

const Index = () => {
  const { width } = useWindowSize();
  const { client } = useStore(
    (state) => ({
      client: state.client,
    }),
    shallow,
  );

  const theme = useTheme();
  // console.log('theme : ' + JSON.stringify(theme));

  const getComponent = () => {
    if (groups.includes(client?.SchoolLeaderGroupName)) {
      if (width < breakpoints.tablet) {
        if (groups?.includes(client?.RegisterGroupName) || groups?.includes(client?.AdminGroupName) || groups?.includes(client?.GuestTeacherGroupName))
          return <RegistrationHandler />;
        else {
          return <LeaderPage />;
        }
      }
      else {
        return <LeaderPage />;
      }

    }
    if (groups.includes(client?.SchoolSecretaryGroupName)) {
      if (width < breakpoints.tablet) {
        if (groups?.includes(client?.RegisterGroupName) || groups?.includes(client?.AdminGroupName) || groups?.includes(client?.GuestTeacherGroupName))
          return <RegistrationHandler />;
        else {
          return <SchoolSecretaryPage />;
        }
      }
      else {
        return <SchoolSecretaryPage />;
      }

    }
    if (groups?.includes(client?.StudentGroupQROnly) && groups?.includes(client?.StudentGroupName)) {
      return <QROnlyPage />;
    } else if (groups?.includes(client?.RegisterGroupName) || groups?.includes(client?.AdminGroupName) || groups?.includes(client?.GuestTeacherGroupName)) {
      return <RegistrationHandler />;
    } else if (groups?.includes(client?.StudentGroupName) && !groups?.includes(client?.StudentGroupQROnly)) {
      return <ProfilePage />;
    } else if (groups.includes(client?.GuardianGroupName)) {
      return <DefaultTemplate><GuardianPage /></DefaultTemplate>;
    } else if (groups?.includes(client?.CaseWorkerGroupName)) {
      return <CounselorPage />;
    } else if (groups?.includes(client?.SuperAdminGroupName)) {
      return <StudentAdminPage />;
    } else if (groups?.includes(client?.RedeemGroupName)) {
      return <RedeemPage />;
    } else if (groups?.includes(client?.RewardAdminGroupName)) {
      return <RewardPage />;
    } else if (groups?.includes(client?.RewardShopClerkGroupName)) {
      return <RedeemQRPage />;
    }  
    else {
      return (
        <LoaderWrapper>
          <DefaultLoader />
        </LoaderWrapper>
      );
    }
  };

  const { groups, error } = useAuthentication();
  return (
    <>
      {groups && client && !error ? (
        getComponent()
      ) : (
        // <ErrorPage errorCode={code} errorText={errorText} />
        <LoaderWrapper>
          <DefaultLoader />
        </LoaderWrapper>
      )}
    </>
  );
};

export default memo(Index);
